/* eslint-disable no-console */
import { AnyAction } from "redux"
import {
  ACCOUNTS_FETCH_CALL,
  ACCOUNTS_FETCH_FAILURE,
  ACCOUNTS_FETCH_SUCCESS,
  SET_ACCOUNT,
  CLEAR_ACCOUNT,
  OPEN_MODAL,
  CLOSE_MODAL,
  FIRST_STEPS_CALL,
  FIRST_STEPS_SUCCESS,
  FIRST_STEPS_FAILURE,
  ACCOUNT_SYSTEM_EVENT_CALL,
  ACCOUNT_SYSTEM_EVENT_SUCCESS,
  ACCOUNT_SYSTEM_EVENT_FAILURE,
  CLEAR_SYSTEM_EVENTS,
  USER_NAME_UPDATED,
  USER_NAME_UPDATED_LOADING,
  USER_NAME_UPDATED_ERROR,
  ACCOUNT_BALANCE_DETAILS_CALL,
  ACCOUNT_BALANCE_DETAILS_SUCCESS,
  ACCOUNT_BALANCE_DETAILS_FAILURE,
  ACCOUNT_BILLINGS_CALL,
  ACCOUNT_BILLINGS_SUCCESS,
  ACCOUNT_BILLINGS_FAILURE,
  ACCOUNT_EVENTS_CALL,
  ACCOUNT_EVENTS_SUCCESS,
  ACCOUNT_EVENTS_FAILURE
} from "./actions-types"

const INITIAL_STATE: App.AccountState = {
  modal: {
    type: "",
    state: false
  },
  listAccounts: {
    accounts: [
      {
        id: "",
        name: "",
        product: "",
        status: "",
        purchasePlan: "",
        purchasePlanStatus: "",
        isEnterprise: false,
        createdAt: "",
        updatedAt: "",
        shouldPayByInvoice: false
      }
    ],
    loading: false,
    totalItems: 0,
    error: ""
  },
  account: {
    id: "",
    name: "",
    product: "",
    status: "",
    purchasePlan: "",
    purchasePlanStatus: "",
    isEnterprise: false,
    createdAt: "",
    updatedAt: "",
    shouldPayByInvoice: false
  },
  firstSteps: {
    firstStepsStatus: {
      hasProduct: false,
      hasEventType: false,
      hasPurchasePlan: false
    },
    loading: false,
    error: ""
  },
  systemEvents: {
    eventsFreeTrial: [
      {
        metadata: {
          freeTrialAdded: "",
          freeTrialAddedBy: ""
        },
        createdAt: ""
      }
    ],
    loading: false,
    error: ""
  },
  userEdit: {
    name: "",
    success: false,
    loading: false,
    error: false
  },
  accountDetails: {
    balance: {
      data: {
        currentBillingValue: 0,
        globalBillingValue: 0,
        selectedPlan: null,
        eventTypesUsageInfo: [],
        isFreeTrialActive: true
      },
      loading: false,
      error: ""
    },
    billings: {
      data: {
        results: [],
        totalItems: 0
      },
      loading: false,
      error: ""
    },
    accountEvents: {
      data: {
        dailyResults: [],
        summary: {
          total: 0,
          variation: 0,
          difference: 0
        },
        eventTypeMap: {}
      },
      loading: false,
      error: ""
    }
  }
}

export default function accountsReducer(state: App.AccountState = INITIAL_STATE, action: AnyAction) {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        modal: {
          type: action.payload.type,
          state: true
        }
      }

    case CLOSE_MODAL:
      return {
        ...state,
        modal: {
          type: "",
          state: false
        }
      }

    case ACCOUNTS_FETCH_CALL:
      console.log("type", action.type)

      return {
        ...state,
        listAccounts: {
          ...state.listAccounts,
          loading: true,
          error: ""
        }
      }

    case ACCOUNTS_FETCH_SUCCESS:
      console.log("type", action)

      return {
        ...state,
        listAccounts: {
          ...state.listAccounts,
          loading: false,
          accounts: action.payload.data.data as App.AccountState["listAccounts"]["accounts"],
          totalItems: action.payload.data.totalItems
        }
      }

    case ACCOUNTS_FETCH_FAILURE:
      console.log("type", action.type)

      return {
        ...state,
        listAccounts: {
          ...state.listAccounts,
          loading: false,
          error: action.payload
        }
      }

    case SET_ACCOUNT:
      return {
        ...state,
        account: action.payload
      }

    case CLEAR_ACCOUNT:
      return {
        ...state,
        account: INITIAL_STATE.account
      }

    case FIRST_STEPS_CALL:
      return {
        ...state,
        firstSteps: {
          ...state.firstSteps,
          loading: true,
          error: ""
        }
      }

    case FIRST_STEPS_SUCCESS:
      return {
        ...state,
        firstSteps: {
          ...state.firstSteps,
          loading: false,
          firstStepsStatus: action.payload as App.AccountState["firstSteps"]["firstStepsStatus"],
          error: ""
        }
      }

    case FIRST_STEPS_FAILURE:
      return {
        ...state,
        firstSteps: {
          ...state.firstSteps,
          loading: false,
          error: action.payload
        }
      }
    case USER_NAME_UPDATED:
      return {
        ...state,
        userEdit: {
          ...state.userEdit,
          success: true,
          error: false,
          loading: false
        }
      }
    case USER_NAME_UPDATED_LOADING:
      return {
        ...state,
        userEdit: {
          ...state.userEdit,
          success: false,
          error: false,
          loading: true
        }
      }
    case USER_NAME_UPDATED_ERROR:
      return {
        ...state,
        userEdit: {
          ...state.userEdit,
          success: false,
          error: action.payload,
          loading: false
        }
      }

    case ACCOUNT_SYSTEM_EVENT_CALL:
      return {
        ...state,
        systemEvents: {
          ...state.systemEvents,
          loading: true,
          error: ""
        }
      }

    case ACCOUNT_SYSTEM_EVENT_SUCCESS:
      return {
        ...state,
        systemEvents: {
          ...state.systemEvents,
          loading: false,
          eventsFreeTrial: action.payload.systemEvents as App.AccountState["systemEvents"]["eventsFreeTrial"],
          error: ""
        }
      }

    case ACCOUNT_SYSTEM_EVENT_FAILURE:
      return {
        ...state,
        systemEvents: {
          ...state.systemEvents,
          loading: false,
          error: action.payload
        }
      }

    case CLEAR_SYSTEM_EVENTS:
      return {
        ...state,
        systemEvents: {
          ...state.systemEvents,
          eventsFreeTrial: []
        }
      }

    case ACCOUNT_BALANCE_DETAILS_CALL:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          balance: {
            ...state.accountDetails.balance,
            loading: true,
            error: ""
          }
        }
      }

    case ACCOUNT_BALANCE_DETAILS_SUCCESS:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          balance: {
            ...state.accountDetails.balance,
            loading: false,
            data: action.payload.data as App.AccountState["accountDetails"]["balance"]["data"],
            error: ""
          }
        }
      }

    case ACCOUNT_BALANCE_DETAILS_FAILURE:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          balance: {
            ...state.accountDetails.balance,
            loading: false,
            error: action.payload
          }
        }
      }

    case ACCOUNT_BILLINGS_CALL:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          billings: {
            ...state.accountDetails.billings,
            loading: true,
            error: ""
          }
        }
      }

    case ACCOUNT_BILLINGS_SUCCESS:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          billings: {
            ...state.accountDetails.billings,
            loading: false,
            data: action.payload.data as App.AccountState["accountDetails"]["billings"]["data"],
            error: ""
          }
        }
      }

    case ACCOUNT_BILLINGS_FAILURE:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          billings: {
            ...state.accountDetails.billings,
            loading: false,
            error: action.payload
          }
        }
      }

    case ACCOUNT_EVENTS_CALL:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          accountEvents: {
            ...state.accountDetails.accountEvents,
            loading: true,
            error: ""
          }
        }
      }

    case ACCOUNT_EVENTS_SUCCESS:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          accountEvents: {
            ...state.accountDetails.accountEvents,
            loading: false,
            data: action.payload.data.accountEvents as App.AccountState["accountDetails"]["accountEvents"]["data"],
            error: ""
          }
        }
      }

    case ACCOUNT_EVENTS_FAILURE:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          accountEvents: {
            ...state.accountDetails.accountEvents,
            loading: false,
            error: action.payload
          }
        }
      }

    default:
      console.log("type default", action.type)

      return state
  }
}
